import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface State {
  id?: string
  name: string
  code: string
  countryId: string
}

export async function getStates(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = '',
): Promise<any> {
  // where's
  let where = []
  if (search) {
    where.push(
      `CONCAT(countries.name, states.name,states.code) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN states.code ~ '^[0-9]+$' THEN CAST(states.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, states.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN states.code ~ '^[0-9]+$' THEN CAST(states.code AS numeric) ELSE NULL END), states.code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_states'],
    fields: [
      'states.id',
      'states.code',
      'states.name',
      'countries.name as country',
      'states.updated_at'
    ],
    join: ['INNER JOIN countries ON states.country_id = countries.id'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getState(id: string): Promise<State> {
  const data = await getData<any>({
    tables: ['pg_states'],
    fields: [
      'states.id',
      'states.code',
      'states.name',
      'states.country_id as countryId',
      'states.custom_fields',
      'countries.iso_code as isoCode',
      'states.custom_fields as custom'
    ],
    where: [`states.id = '${id}'`],
    join: ['INNER JOIN countries ON states.country_id = countries.id'],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createState(data: State): Promise<boolean> {
  const response: any = await http.post('country/states', {
    countryId: data.countryId,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateState(data: State, id: string): Promise<boolean> {
  const response: any = await http.put('country/states/' + id, {
    countryId: data.countryId,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteState(id: string): Promise<boolean> {
  const response: any = await http.delete('country/states/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
